import { render, staticRenderFns } from "./modify.vue?vue&type=template&id=0133768f&scoped=true"
import script from "./modify.vue?vue&type=script&lang=js"
export * from "./modify.vue?vue&type=script&lang=js"
import style0 from "./modify.vue?vue&type=style&index=0&id=0133768f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0133768f",
  null
  
)

export default component.exports